import { createContext, useContext, useEffect, useMemo, useState } from "react";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [user, setUser_] = useState();
  const [station, setStation_] = useState();

  const setUser = (newUser) => {
    setUser_(newUser);
  };

  const setStation = (newStation) => {
    setStation_(newStation);
  };

  useEffect(() => {}, []);

  const contextValue = useMemo(
    () => ({
      user,
      setUser,
      station,
      setStation,
    }),
    [user, station]
  );

  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};

export default AuthProvider;
